const messages = {
  UNKNOWN_ERROR: 'An unknown error occurred',

  // validation message
  MAX_30_CHAR_MESSAGE: 'Max 30 characters allowed',
  MAX_10_CHAR_MESSAGE: 'Max 10 characters allowed',
  MAX_256_CHAR_MESSAGE: 'Max 256 characters allowed',
  MAX_500_CHAR_MESSAGE: 'Max 500 characters allowed',
  INVALID_VALUE_MESSAGE: 'Invalid value',
  FAILD_TO_SAVE_MFG: 'Failed to save manufacturer',
  MAX_3_CHAR_MESSAGE: 'Max 3 characters allowed',
  MAX_48_CHAR_MESSAGE: 'Max 48 characters allowed',
  MAX_2_CHAR_MESSAGE: 'Max 2 characters allowed',
  MAX_11_CHAR_MESSAGE: 'Max 11 characters allowed',
  MAX_4_CHAR_MESSAGE: 'Max 4 characters allowed',
  MAX_6_CHAR_MESSAGE: 'Max 6 characters allowed',
  MAX_15_CHAR_MESSAGE: 'Max 15 characters allowed',
  MAX_50_CHAR_MESSAGE: 'Max 50 characters allowed',
  MAX_80_CHAR_MESSAGE: 'Max 80 characters allowed',
  MAX_1_CHAR_MESSAGE: 'Max 1 characters allowed',
};

export default messages;
